// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","col":"Footer_col__b2mRd","legal_footer":"Footer_legal_footer__dy8Ow","copyright":"Footer_copyright__Yoh4-"};